import React from "react";
import ScheduleDogyo from "components/comp/ScheduleDogyo";
import ScheduleJobShop from "components/comp/ScheduleJobShop";
import ScheduleAlgo from "components/comp/ScheduleAlgo";
import CompYoutube from "components/comp/CompYoutube";
import SubPicture from "components/comp/SubPicture";
import ProductImg from "assets/images/prod.png"

// 삭제 요청 없음: ScheduleProcess는 competency/process에서 사용. 이 페이지에서는 도교/잡숍/알고리즘만 유지.

// why: 계획 스케줄링 소개/데모를 전용 페이지에서 제공

const ProductScheduler = () => {
  const url = "http://schedule.hyds.kr/"
  
  return (
    <main className="page-sub">
      <section className="company-main">
      <SubPicture img={ProductImg}/>
        <ScheduleDogyo/>
        <ScheduleJobShop/>
        <ScheduleAlgo/>
        <CompYoutube/>
        <div className="btn-container">
          <button className="btn btn-more" onClick={()=>{window.open(url)}}>섬유 공정 스케줄러 바로가기</button>
        </div>
      </section>
    </main>
  );
};

export default ProductScheduler;


